import { Pipe, PipeTransform } from "@angular/core";


// Ao utilizar este pipe, deve-se somente importar o share.module no modulo de sua tela, pois o share module já exporta. 
// Isso deve ser feito para não ocorrer de dupla importação em modulos do mesmo nível.


// Neste pipe, quando é passado argumento para o discriminator, é filtrado, ao contrário, é considerado todos.
// soma: 'coluna a ser somada' : 'filtro discriminator se necessário' // quando há filtro
// soma: 'coluna a ser somada' // quando não há filtro


@Pipe({
  name: "soma",
})
export class SomaPipe implements PipeTransform {
  transform(itens: any[], atributo: string, discriminator?: string): any {

    return itens.filter(i => discriminator ? i.discriminator === discriminator : i).reduce((a, b) => a + b[atributo], 0)

    // return itens.reduce((a, b) => a + b[atributo], 0);
    
  }
}
